module.exports = __webpack_public_path__ + "img/model1.f8debb4b.png";